export const enableButton = button => {
  if (!button) {
    return;
  }

  button.classList.remove('disabled');
  button.disabled = false;
}

export const disableButton = button => {
  if (!button) {
    return;
  }

  button.disabled = true;
  button.classList.add('disabled');
}

export const toggle = (target) => {
  if (target.classList.contains('show')){
    target.classList.remove('show');
    target.classList.add('fade');
  }
  else{
    target.classList.add('show');
    target.classList.remove('fade');
  }
}

export const clearNodeContent = (node) => {
  node.classList.add('d-none');
  node.textContent = '';
}

export const setNodeContent = (node, content) => {
  node.classList.remove('d-none');
  node.textContent = content;
}

export const clearObjectFields = (obj = {}) => {
  for (key in obj) {
    if (obj.hasOwnProperty(key) && obj[key].hasOwnProperty('value')) {
      obj[key].value = '';
    }
  }
}

export const initializeAccordion = (container) => {
  if (!container) return;

  const buttons = container.getElementsByClassName("accordion-button");

  Array.from(buttons).forEach((button) => {
    button.addEventListener("click", function () {
      this.classList.toggle("active");
      const panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
        panel.style.border = "none";
      } else {
        panel.style.maxHeight = `${panel.scrollHeight + 40}px`;
        panel.style.border = "2px solid rgba(var(--dtu-sys-rgb-object-primaryPalette-80), 1)";
        panel.style.borderTop = "none";
      }
    });
  });
};
